/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import AudienceItem from './AudienceItem';
import * as S from './ExistingAudience.styled';
import { cloneDeep } from 'lodash-es';

function compareItems(a, b) {
  return a.cust_aud_number - b.cust_aud_number;
}

const Content = ({ data, selectedAud, setSelectedAud, isChanged, search }) => {
  const sortedAllAud = useMemo(() => {
    const newArr = cloneDeep(data);
    newArr.sort(compareItems).reverse();
    const selected = newArr.filter(
      ({ cust_aud_number }) => cust_aud_number === selectedAud?.custAudNumber,
    );
    const notSelected = newArr.filter(
      ({ cust_aud_number }) => cust_aud_number !== selectedAud?.custAudNumber,
    );
    return [...selected, ...notSelected];
  }, [data]);

  return (
    <S.ContentContainer>
      {sortedAllAud.map((item) => {
        return (
          <AudienceItem
            search={search}
            isChanged={isChanged}
            key={item.cust_aud_number}
            {...item}
            custAudNumber={selectedAud?.custAudNumber}
            setSelectedAud={setSelectedAud}
          />
        );
      })}
    </S.ContentContainer>
  );
};

export default Content;
